/**
 * @generated SignedSource<<bd50d9f19dc26e823c7e62b35b5cc1dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FormSearchFieldsEnum = "AuthorId" | "Content" | "Created" | "Description" | "Email" | "Id" | "ImageUrl" | "MarketingConsent" | "Metadata" | "Modified" | "Password" | "Schema" | "Status" | "StatusSettings" | "Title" | "UiSchema";
export type OrderEnum = "ASC" | "DESC";
export type PostObjectsConnectionDateColumnEnum = "DATE" | "MODIFIED";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FAILED" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "IN_PROGRESS" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type RelationEnum = "AND" | "OR";
export type RootQueryToFormConnectionWhereArgs = {
  authorId?: string | null | undefined;
  authorIdIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  authorIdNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  content?: string | null | undefined;
  createdDateQuery?: DateQueryInput | null | undefined;
  description?: string | null | undefined;
  id?: string | null | undefined;
  idIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  idNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  imageUrl?: string | null | undefined;
  marketingConsent?: boolean | null | undefined;
  modifiedDateQuery?: DateQueryInput | null | undefined;
  order?: OrderEnum | null | undefined;
  orderBy?: ReadonlyArray<FormSearchFieldsEnum | null | undefined> | null | undefined;
  schema?: string | null | undefined;
  search?: string | null | undefined;
  searchFields?: ReadonlyArray<FormSearchFieldsEnum | null | undefined> | null | undefined;
  status?: PostStatusEnum | null | undefined;
  statusIn?: ReadonlyArray<PostStatusEnum | null | undefined> | null | undefined;
  statusNotIn?: ReadonlyArray<PostStatusEnum | null | undefined> | null | undefined;
  title?: string | null | undefined;
  uiSchema?: string | null | undefined;
};
export type DateQueryInput = {
  after?: DateInput | null | undefined;
  before?: DateInput | null | undefined;
  column?: PostObjectsConnectionDateColumnEnum | null | undefined;
  compare?: string | null | undefined;
  day?: number | null | undefined;
  hour?: number | null | undefined;
  inclusive?: boolean | null | undefined;
  minute?: number | null | undefined;
  month?: number | null | undefined;
  relation?: RelationEnum | null | undefined;
  second?: number | null | undefined;
  week?: number | null | undefined;
  year?: number | null | undefined;
};
export type DateInput = {
  day?: number | null | undefined;
  month?: number | null | undefined;
  year?: number | null | undefined;
};
export type Forms_Search_Query$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  where?: RootQueryToFormConnectionWhereArgs | null | undefined;
};
export type Forms_Search_Query$data = {
  readonly forms: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly content: string | null | undefined;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly status: PostStatusEnum | null | undefined;
        readonly title: string;
      };
    }>;
  } | null | undefined;
};
export type Forms_Search_Query = {
  response: Forms_Search_Query$data;
  variables: Forms_Search_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": 12,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "where"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "RootQueryToFormConnection",
    "kind": "LinkedField",
    "name": "forms",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RootQueryToFormConnectionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Form",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Forms_Search_Query",
    "selections": (v3/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "Forms_Search_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "ddaf8632364a2f4b81bbc9c3d6988cab",
    "id": null,
    "metadata": {},
    "name": "Forms_Search_Query",
    "operationKind": "query",
    "text": "query Forms_Search_Query(\n  $first: Int = 12\n  $after: String\n  $where: RootQueryToFormConnectionWhereArgs\n) {\n  forms(first: $first, after: $after, where: $where) {\n    edges {\n      node {\n        id\n        title\n        status\n        content\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "89755833b97cf5fbcbf76226e2bc3266";

export default node;
